// Thai copy for /preview-first-uploads (polite, "คุณ", not stiff), translated from copy.en.ts. Same shape
// (checked by copy.test.ts). The second pass is always "ไฟล์ต้นฉบับ" (never "คุณภาพเต็ม"). The uploader's own
// labels are in English, so they're quoted as it shows them.
import type { PreviewFirstCopy } from "./copy.en";

const th: PreviewFirstCopy = {
  seo: {
    title: "อัปโหลดภาพพรีวิวก่อน ทุกแพ็กเกจ | Photohawk",
    description:
      "ใหม่ในตัวอัปโหลดบนเว็บของ Photohawk สำหรับทุกแพ็กเกจ: ภาพพรีวิวขนาดเล็กของแต่ละภาพจะขึ้นก่อน แกลเลอรีของคุณจึงออนไลน์ ขาย และแชร์ได้ภายในไม่กี่นาที ขณะที่ไฟล์ต้นฉบับทยอยตามมาในเบื้องหลัง",
  },
  hero: {
    badge: "ใหม่",
    eyebrow: "ในตัวอัปโหลดบนเว็บ · ทุกแพ็กเกจ",
    title: "แกลเลอรีของคุณออนไลน์ได้ในไม่กี่นาที",
    titleHighlight: "ไม่ต้องรอเป็นชั่วโมง",
    subtitle:
      "ตอนนี้ตัวอัปโหลดบนเว็บจะส่งภาพพรีวิวขนาดเล็กของทุกภาพขึ้นไปก่อน แกลเลอรีของคุณออนไลน์ได้ด้วยภาพพรีวิวเหล่านั้น ผู้ซื้อจึงค้นหา ซื้อ และแชร์ภาพของตัวเองได้ ขณะที่ไฟล์ต้นฉบับยังอัปโหลดต่อในเบื้องหลัง",
    ctaPrimary: "เปิดตัวอัปโหลด",
    ctaSecondary: "ดูวิธีการทำงาน",
    uploaderLink: "ดูทุกสิ่งใหม่ในตัวอัปโหลดบนเว็บ",
  },
  steps: {
    heading: "วิธีการทำงาน",
    subtitle: "ฟีเจอร์ภาพพรีวิวขึ้นก่อนมีในตัวอัปโหลดบนเว็บทุกแพ็กเกจ เมื่อคุณเพิ่มภาพ ระบบจะแสดงเวลาที่ใช้ของแต่ละวิธี แล้วคุณเลือก “Previews first, originals later”",
    stepLabel: "ขั้นตอนที่ {n}",
    items: [
      {
        id: "add",
        title: "เพิ่มภาพของคุณ",
        body: "ลากภาพหรือทั้งโฟลเดอร์มาวางได้เหมือนเดิม เบราว์เซอร์จะสร้างภาพพรีวิวขนาดเล็กของแต่ละภาพบนคอมพิวเตอร์ของคุณเอง",
      },
      {
        id: "previews",
        title: "ภาพพรีวิวขึ้นก่อน",
        body: "ภาพพรีวิวมีขนาดเล็ก จึงอัปโหลดได้เร็ว แม้อินเทอร์เน็ตที่หน้างานจะช้า",
      },
      {
        id: "live",
        title: "แกลเลอรีของคุณออนไลน์",
        body: "เผยแพร่ได้ทันทีที่ภาพพรีวิวขึ้นครบ หรือติ๊ก “Publish the gallery as soon as the previews are up” ไว้ ระบบจะเผยแพร่ให้เอง ผู้ซื้อเลือกดู ค้นหา ซื้อ และแชร์ได้ทันที",
      },
      {
        id: "full",
        title: "ไฟล์ต้นฉบับตามมา",
        body: "ไฟล์ต้นฉบับยังอัปโหลดต่อในเบื้องหลัง เข้าไปยังภาพเดิมเหล่านั้น การดาวน์โหลดและการพิมพ์ใช้ไฟล์ต้นฉบับเสมอ",
      },
    ],
    timeline: {
      label: "ตัวอย่างการอัปโหลด ตั้งแต่ต้นจนจบ",
      previews: "ภาพพรีวิว",
      previewsTime: "ไม่กี่นาที",
      live: "แกลเลอรีออนไลน์",
      full: "ไฟล์ต้นฉบับ",
      fullTime: "ในเบื้องหลัง",
    },
  },
  buyers: {
    heading: "สิ่งที่ผู้ซื้อเห็น",
    subtitle: "ไม่มีอะไรใหม่ให้ต้องเรียนรู้ ผู้ซื้อได้เห็นแกลเลอรีแบบที่คุ้นเคย เพียงแต่เร็วขึ้น",
    items: [
      {
        id: "protected",
        title: "มีลายน้ำและได้รับการปกป้องเหมือนเดิม",
        body: "ผู้ซื้อจะเห็นภาพพรีวิวที่มีลายน้ำแบบเดิม และการปกป้องภาพพรีวิวก็ทำงานเหมือนเดิมหากแกลเลอรีของคุณเปิดใช้อยู่",
      },
      {
        id: "search",
        title: "หาตัวเองเจอได้ทันที",
        body: "การค้นหาด้วยเซลฟี่และเลขบิบใช้ได้กับภาพพรีวิว ทุกคนจึงหาภาพของตัวเองเจอทันทีที่แกลเลอรีออนไลน์",
      },
      {
        id: "delivery",
        title: "ส่งไฟล์ต้นฉบับให้อัตโนมัติ",
        body: "การซื้อหรือการดาวน์โหลดฟรีจะไม่ได้รับภาพพรีวิวเด็ดขาด หากมีคนซื้อหรือดาวน์โหลดภาพก่อนที่ไฟล์ต้นฉบับจะมาถึง ไฟล์ต้นฉบับนั้นจะได้ลัดคิวขึ้นก่อน และส่งถึงผู้ซื้อทันทีที่พร้อม",
      },
    ],
  },
  strip: {
    heading: "ติดตามได้ตลอดระหว่างอัปโหลด",
    body: "ระหว่างที่ภาพพรีวิวและไฟล์ต้นฉบับกำลังอัปโหลด แถบด้านบนของตัวอัปโหลดจะแสดงสถานะของแกลเลอรี ทั้งออนไลน์แล้วหรือยัง ไฟล์ต้นฉบับเหลืออีกเท่าไร และภาพที่มีคนซื้อได้ลัดคิวไปแล้วเมื่อไร เมื่อแกลเลอรีออนไลน์แล้ว แถบนี้ยังแสดงจำนวนผู้เข้าชมในช่วง 30 นาทีที่ผ่านมา และเจ้าของกับผู้ดูแลพื้นที่ทำงานจะเห็นคำสั่งซื้อใหม่นับตั้งแต่เริ่มอัปโหลด",
    exampleLabel: "ตัวอย่าง",
    live: "ออนไลน์ด้วยภาพพรีวิว",
    orders: "3 คำสั่งซื้อตั้งแต่คุณเริ่ม",
    visitors: "ผู้เข้าชม 42 คนใน 30 นาทีที่ผ่านมา",
    left: "เหลือไฟล์ต้นฉบับอีก 1,250 ไฟล์",
    jumped: "ไฟล์ต้นฉบับของภาพที่มีคนสั่งซื้อ 2 ภาพได้ลัดคิวแล้ว",
  },
  faq: {
    heading: "คำถามที่พบบ่อย",
    items: [
      {
        q: "ต้องเปิดตัวอัปโหลดค้างไว้ไหม",
        a: "ควรเปิดไว้จนกว่าไฟล์ต้นฉบับจะอัปโหลดเสร็จ แถบด้านบนจะบอกว่าเหลืออีกเท่าไร หากปิดก่อนก็ไม่มีอะไรสูญหาย แกลเลอรียังคงออนไลน์ด้วยภาพพรีวิว และครั้งหน้าที่คุณเปิดแกลเลอรีนั้นในตัวอัปโหลด ระบบจะบอกว่ายังมีภาพรออยู่กี่ภาพ เพิ่มโฟลเดอร์เดิมอีกครั้ง (จะทำทีหลังจากที่บ้านก็ได้) ระบบจะส่งเฉพาะไฟล์ต้นฉบับที่ยังขาด",
      },
      {
        q: "ถ้ามีคนซื้อภาพก่อนที่ไฟล์ต้นฉบับจะมาถึงล่ะ",
        a: "ซื้อได้ตามปกติ ระหว่างที่ตัวอัปโหลดทำงานอยู่ ไฟล์ต้นฉบับของภาพนั้นจะได้ลัดคิวขึ้นก่อน อีเมลยืนยันคำสั่งซื้อจะรอไฟล์ และส่งออกไปภายในไม่กี่นาทีหลังไฟล์มาถึง ผู้ซื้อจึงไม่มีทางได้รับภาพพรีวิวโดยไม่ตั้งใจ หากตัวอัปโหลดถูกปิดไปแล้ว คำสั่งซื้อจะรอจนกว่าคุณจะเพิ่มโฟลเดอร์นั้นอีกครั้ง ตัวอัปโหลดจะบอกคุณว่ามีผู้ซื้อรอภาพไหนอยู่ และภาพเหล่านั้นจะขึ้นก่อน",
      },
      {
        q: "ใช้กับแกลเลอรีที่ให้ดาวน์โหลดฟรีได้ไหม",
        a: "ได้ ทุกคนดู ค้นหา และดาวน์โหลดได้ทันทีที่ภาพพรีวิวขึ้นครบ และการดาวน์โหลดจะไม่ใช่ภาพพรีวิวเด็ดขาด หากมีคนดาวน์โหลดภาพก่อนที่ไฟล์ต้นฉบับจะมาถึง ไฟล์ต้นฉบับนั้นจะได้ลัดคิวขึ้นก่อน หน้าดาวน์โหลดจะแสดงว่าไฟล์ต้นฉบับกำลังอัปโหลด และกลายเป็นลิงก์ดาวน์โหลดที่ใช้ได้ทันทีที่ไฟล์มาถึง การดาวน์โหลดทางอีเมลก็จะส่งออกไปในตอนนั้นเช่นกัน การดาวน์โหลดแต่ละครั้งนับเพียงครั้งเดียว",
      },
      {
        q: "การค้นหาด้วยเซลฟี่และเลขบิบใช้กับภาพพรีวิวได้ไหม",
        a: "ได้ ระบบตรวจหาใบหน้าและเลขบิบจากภาพพรีวิว การค้นหาจึงใช้ได้ทันทีที่ภาพพรีวิวขึ้น ระหว่างที่ตัวอัปโหลดเปิดอยู่ ระบบยังส่งภาพระยะใกล้ที่คมชัดกว่าจากไฟล์ต้นฉบับของคุณขึ้นไปด้วยเพื่อช่วยการค้นหา",
      },
      {
        q: "แพ็กเกจไหนมีฟีเจอร์นี้",
        a: "ทุกแพ็กเกจ รวมถึง Lite หากพื้นที่ทำงานของคุณเคยใช้ภาพพรีวิวขึ้นก่อนมาแล้ว ภาพเหล่านั้นยังอัปโหลดให้เสร็จได้ตามปกติ เพิ่มโฟลเดอร์เดิมอีกครั้ง ระบบจะส่งไฟล์ต้นฉบับของภาพเหล่านั้น และคำสั่งซื้อกับการดาวน์โหลดยังส่งถึงตามปกติ",
      },
      {
        q: "มีค่าใช้จ่ายเพิ่มไหม",
        a: "ไม่มี ฟีเจอร์นี้รวมอยู่ในทุกแพ็กเกจ และแต่ละภาพนับเพียงครั้งเดียว เพราะภาพพรีวิวกับไฟล์ต้นฉบับคือภาพเดียวกัน ความต่างเพียงอย่างเดียวคือการเชื่อมต่อของคุณจะส่งข้อมูลรวมมากขึ้นเล็กน้อย (ประมาณ 5%)",
      },
      {
        q: "ใช้กับ FTP และ Photohawk Studio ได้ไหม",
        a: "ตอนนี้ยังไม่ได้ ภาพพรีวิวขึ้นก่อนเป็นฟีเจอร์ของตัวอัปโหลดบนเว็บ ภาพที่ส่งผ่าน FTP หรือจาก Photohawk Studio จะอัปโหลดเป็นไฟล์ต้นฉบับในครั้งเดียวเหมือนเดิม",
      },
      {
        q: "เปิดใช้เป็นค่าเริ่มต้นไหม",
        a: "ไม่ ทุกครั้งที่คุณเพิ่มภาพ ตัวอัปโหลดบนเว็บจะแสดงเวลาที่ใช้ทั้งแบบมีและไม่มีภาพพรีวิวขึ้นก่อน โดยเลือกการส่งไฟล์ต้นฉบับทันทีไว้ให้ เลือก “Previews first, originals later” เมื่อต้องการให้แกลเลอรีออนไลน์เร็วขึ้น ระบบจะจำตัวเลือกของคุณไว้ใช้ครั้งถัดไป หากเลือกความละเอียดในการอัปโหลดที่เล็กลง (“Large” หรือ “Web”) ระบบจะอัปโหลดเฉพาะไฟล์ที่ย่อขนาดแล้ว จึงไม่ใช้ภาพพรีวิวขึ้นก่อน",
      },
    ],
  },
  cta: {
    heading: "ลองใช้ในการอัปโหลดครั้งถัดไป",
    body: "ฟีเจอร์ภาพพรีวิวขึ้นก่อนมีในตัวอัปโหลดบนเว็บทุกแพ็กเกจ เพิ่มภาพของคุณ เลือกภาพพรีวิวขึ้นก่อน แล้วแกลเลอรีจะออนไลน์ได้ในไม่กี่นาที",
    button: "เปิดตัวอัปโหลด",
  },
};

export default th;
